var SkeletonVariant = /* @__PURE__ */ ((SkeletonVariant2) => {
  SkeletonVariant2["Button"] = "button";
  SkeletonVariant2["Checkbox"] = "checkbox";
  SkeletonVariant2["Circular"] = "circular";
  SkeletonVariant2["MultilineTextField"] = "multilineTextField";
  SkeletonVariant2["NumberedStep"] = "numberedStep";
  SkeletonVariant2["PillBadge"] = "pillBadge";
  SkeletonVariant2["QuantitySelector"] = "quantitySelector";
  SkeletonVariant2["RadioButton"] = "radioButton";
  SkeletonVariant2["Rectangular"] = "rectangular";
  SkeletonVariant2["Select"] = "select";
  SkeletonVariant2["SelectorCheckbox"] = "selectorCheckbox";
  SkeletonVariant2["SelectorRadioButton"] = "selectorRadioButton";
  SkeletonVariant2["TextBody"] = "textBody";
  SkeletonVariant2["TextField"] = "textField";
  SkeletonVariant2["TextHeader"] = "textHeader";
  SkeletonVariant2["TextMultipleLines"] = "textMultipleLines";
  return SkeletonVariant2;
})(SkeletonVariant || {});
export {
  SkeletonVariant
};
